import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { makePickSavingField } from '@helpers/makePickSavingField';

import { apiClient } from '@services/apiClient';

import { type IArchivedAiFilterResponse } from '../model/archivedAi';

export const archivedAiFilterDataKey = (locationIds: Array<number>): [string, Array<number>] => [
  'archivedAiList',
  locationIds,
];

const archivedAiFilterDataFn = ({ queryKey }: QueryFunctionContext<string[]>) =>
  apiClient.get<{ data: IArchivedAiFilterResponse }>(
    `${APP_API_URL_V2}fsd/action-item/report/archived-action-items/filter`,
    {
      params: {
        location_ids: queryKey[1],
      },
    },
  );

const archivedAiFilterDataSelect =
  (locationIds?: Array<number>) =>
  ({ data }: AxiosResponse<{ data: IArchivedAiFilterResponse }>) => {
    const pick = makePickSavingField(!locationIds);

    const {
      maxCostAvoidedCustomerCurrency,
      maxCostAvoidedFacilityCurrency,
      minCostAvoidedCustomerCurrency,
      minCostAvoidedFacilityCurrency,
      ...rest
    } = data.data;

    return {
      ...rest,
      maxCostAvoided: pick(maxCostAvoidedCustomerCurrency, maxCostAvoidedFacilityCurrency),
      minCostAvoided: pick(minCostAvoidedCustomerCurrency, minCostAvoidedFacilityCurrency),
    };
  };

export const useArchivedAiFilterDataQuery = (locationIds: Array<number>) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: archivedAiFilterDataKey(locationIds),
    queryFn: archivedAiFilterDataFn,
    select: archivedAiFilterDataSelect(locationIds),
  });
};
